import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import { Navbar } from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import axios from "axios";
import { var_api } from "../constant";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";

const Membershipmaster = () => {
  const [editMode, setEditMode] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
  const [searchQuery, setSearchQuery] = useState('');
  const history = useHistory();
  const [membershipList, setMembershipList] = useState([]);
  const [membershipId, setMembershipId] = useState('');
  const [activeStatus, setActiveStatus] = useState(1); // Add this line

  
  // Form fields
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [validityFrom, setValidityFrom] = useState('');
  const [validityTo, setValidityTo] = useState('');
  const [cardValueAmount, setCardValueAmount] = useState('');
  const [colorTheme, setColorTheme] = useState('#598047');
  const [cardImage, setCardImage] = useState(null);
  const [cardImagePreview, setCardImagePreview] = useState('');
  
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchMembershipMasterData();
  }, [currentPage]);

  const fetchMembershipMasterData = async () => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    try {
      const response = await axios.get(`${var_api}/api/membership-master/get`, {
        headers: {
          'Authorization': `${token}`
        }
      });
      setMembershipList(response.data);
      setIsLogin(false);
    } catch (error) {
      setMembershipList([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!name) newErrors.name = 'Membership Name is required';
    if (!description) newErrors.description = 'Description is required';
    if (!validityFrom) newErrors.validityFrom = 'Validity From Date is required';
    if (!validityTo) newErrors.validityTo = 'Validity To Date is required';
    if (validityFrom && validityTo && new Date(validityFrom) > new Date(validityTo)) {
      newErrors.validityTo = 'Validity To must be after Validity From';
    }
    if (!cardValueAmount || cardValueAmount <= 0) newErrors.cardValueAmount = 'Valid Card Value Amount is required';
    if (!colorTheme) newErrors.colorTheme = 'Color Theme is required';

    return newErrors;
  };

const createMembershipMaster = async () => {
  const newErrors = validateForm();
  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) return;

  const token = localStorage.getItem('token');
  setIsLogin(true);

  // Calculate validity days
  const fromDate = new Date(validityFrom);
  const toDate = new Date(validityTo);
  const validityDays = Math.ceil((toDate - fromDate) / (1000 * 60 * 60 * 24));

  const formData = new FormData();
  formData.append('name', name);
  formData.append('description', description);
  formData.append('validity_days', validityDays);
  formData.append('card_value_amt', cardValueAmount);
  formData.append('active_status', 1); // default active
  formData.append('color_theme', colorTheme);

  if (cardImage) {
    formData.append('color_img', cardImage);
  }

  try {
    const response = await axios.post(
      `${var_api}/api/membership-master/post`,
      formData,
      {
        headers: {
          Authorization: `${token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    if (response.status === 200 || response.status === 201) {
      Swal.fire({
        icon: 'success',
        text: 'Membership Created Successfully',
        confirmButtonColor: '#007500',
      });
    }

    fetchMembershipMasterData();
    resetForm();

  } catch (error) {
    console.error('Error:', error);
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: error.response?.data?.error || 'Something went wrong!',
      confirmButtonColor: '#007500',
    });
  } finally {
    setIsLogin(false);
  }
};

const updateMembershipMaster = async () => {
  const newErrors = validateForm();
  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) return;

  const token = localStorage.getItem('token');
  setIsLogin(true);

  const fromDate = new Date(validityFrom);
  const toDate = new Date(validityTo);
  const validityDays = Math.ceil((toDate - fromDate) / (1000 * 60 * 60 * 24));

  const formData = new FormData();
  formData.append('name', name);
  formData.append('description', description);
  formData.append('validity_days', validityDays);
  formData.append('card_value_amt', cardValueAmount);
  formData.append('active_status', activeStatus);
  formData.append('color_theme', colorTheme);

  if (cardImage) {
    formData.append('color_img', cardImage);
  }

  try {
    const response = await axios.put(
      `${var_api}/api/membership-master/put/${membershipId}`,
      formData,
      {
        headers: {
          Authorization: `${token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    if (response.status === 200) {
      Swal.fire({
        icon: 'success',
        text: 'Membership Updated Successfully',
        confirmButtonColor: '#007500',
      });
    }

    fetchMembershipMasterData();
    resetForm();

  } catch (error) {
    console.error('Error:', error);
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: error.response?.data?.error || 'Something went wrong!',
      confirmButtonColor: '#007500',
    });
  } finally {
    setIsLogin(false);
  }
};

// FIXED: Status toggle function - get current data first, then update only status
const handleStatusChange = async (membership, newStatus) => {
  const token = localStorage.getItem('token');
  setIsLogin(true);

  try {
    // First, get the current membership data
    const currentResponse = await axios.get(`${var_api}/api/membership-master/get/${membership.id}`, {
      headers: {
        'Authorization': `${token}`
      }
    });
    
    const currentData = currentResponse.data;
    
    // Create update payload with ALL current data, only changing active_status
    const payload = {
      name: currentData.name,
      description: currentData.description,
      validity_days: currentData.validity_days,
      card_value_amt: currentData.card_value_amt,
      active_status: newStatus,
      color_theme: currentData.color_theme
      // Note: color_img is handled separately if it's a file upload
    };

    const response = await axios.put(
      `${var_api}/api/membership-master/put/${membership.id}`,
      payload,
      {
        headers: {
          Authorization: `${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (response.status === 200) {
      Swal.fire({
        icon: 'success',
        text: 'Membership Status Updated',
        confirmButtonColor: '#007500',
      });
    }

    fetchMembershipMasterData();

  } catch (error) {
    console.error('Error:', error);
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: error.response?.data?.error || 'Something went wrong!',
      confirmButtonColor: '#007500',
    });
  } finally {
    setIsLogin(false);
  }
};

  const resetForm = () => {
    setName('');
    setDescription('');
    setValidityFrom('');
    setValidityTo('');
    setCardValueAmount('');
    setColorTheme('#598047');
    setCardImage(null);
    setCardImagePreview('');
    setEditMode(false);
    setMembershipId('');
    setActiveStatus(1);
    setErrors({});
  };

// FIXED: Edit function with proper date calculation
const handleEdit = (membership) => {
  console.log('Editing membership:', membership);
  
  setEditMode(true);
  setMembershipId(membership.id);
  setName(membership.name || '');
  setDescription(membership.description || '');
  
  // Set dates based on validity_days
  if (membership.validity_days > 0) {
    const today = new Date();
    const fromDate = new Date(membership.validity_from || today);
    const toDate = new Date(membership.validity_to || new Date(fromDate.getTime() + membership.validity_days * 24 * 60 * 60 * 1000));
    
    // Format dates as YYYY-MM-DD for date inputs
    const formatDateForInput = (date) => {
      if (!date) return '';
      try {
        return date.toISOString().split('T')[0];
      } catch (error) {
        console.error('Error formatting date:', error);
        return '';
      }
    };
    
    setValidityFrom(formatDateForInput(fromDate));
    setValidityTo(formatDateForInput(toDate));
  } else {
    // If no validity dates, set empty
    setValidityFrom('');
    setValidityTo('');
  }
  
  setCardValueAmount(membership.card_value_amt || membership.card_value_amount || '');
  setColorTheme(membership.color_theme || '#598047');
  setActiveStatus(membership.active_status || 1);
  
  if (membership.card_image_url || membership.color_img) {
    setCardImagePreview(membership.card_image_url || membership.color_img || '');
  } else {
    setCardImagePreview('');
  }
  
  // Clear the file input
  setCardImage(null);
  
  // Clear any existing errors
  setErrors({});
  
  console.log('Form values set for editing:', {
    name: membership.name,
    description: membership.description,
    validityFrom: validityFrom,
    validityTo: validityTo,
    cardValueAmount: membership.card_value_amt || membership.card_value_amount,
    colorTheme: membership.color_theme,
    activeStatus: membership.active_status
  });
};

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCardImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setCardImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter membership list
  const filteredMemberships = Array.isArray(membershipList) && membershipList.filter(membership => {
    const searchLower = searchQuery.toLowerCase();
    return (
      (membership.name && membership.name.toLowerCase().includes(searchLower)) ||
      (membership.description && membership.description.toLowerCase().includes(searchLower)) ||
      (membership.card_value_amt && membership.card_value_amt.toString().includes(searchLower))
    );
  });

  // Apply pagination
  const paginatedMemberships = filteredMemberships.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      {isLogin && <div>Loading...</div>}
      <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
        <Navbar.Brand href="#home">
          {/* <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} /> */}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mx-auto">
            <Nav.Link href="#" style={{ color: "black", fontSize: "25px", letterSpacing: "2px" }}>
              MEMBERSHIP MASTER
            </Nav.Link>
          </Nav>
          <Nav className="ms-auto">
            <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
              <button className="btn" style={{ backgroundColor: "rgb(89, 128, 71)", color: "white" }}>
                <i className="bi bi-house"></i> Go to home
              </button>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <br />
      <br />
      <br />
      <br />
      <div style={{ margin: "auto", padding: "20px" }}>
        <Row>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <Card style={{ border: "none", maxWidth: "28rem", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
              <Card.Body>
                <h5 style={{ textAlign: "center", color: "rgb(89, 128, 71)", fontWeight: "bold" }}>{editMode ? 'Edit Membership' : 'Create Membership'}</h5>
                <Form onSubmit={(e) => e.preventDefault()}>
                  <Form.Group controlId="formBasicName" className="mt-3">
                    <Form.Label>Membership Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Membership Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                    {errors.name && <p style={{ color: 'red' }}>{errors.name}</p>}
                  </Form.Group>

                  <Form.Group controlId="formBasicDescription" className="mt-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      placeholder="Enter Description"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      required
                    />
                    {errors.description && <p style={{ color: 'red' }}>{errors.description}</p>}
                  </Form.Group>

                  <Row className="mt-3">
                    <Col>
                      <Form.Group controlId="formBasicValidityFrom">
                        <Form.Label>Validity From</Form.Label>
                        <Form.Control
                          type="date"
                          value={validityFrom}
                          onChange={(e) => setValidityFrom(e.target.value)}
                          required
                        />
                        {errors.validityFrom && <p style={{ color: 'red' }}>{errors.validityFrom}</p>}
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="formBasicValidityTo">
                        <Form.Label>Validity To</Form.Label>
                        <Form.Control
                          type="date"
                          value={validityTo}
                          onChange={(e) => setValidityTo(e.target.value)}
                          required
                        />
                        {errors.validityTo && <p style={{ color: 'red' }}>{errors.validityTo}</p>}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group controlId="formBasicCardValue" className="mt-3">
                    <Form.Label>Card Value Amount ($)</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter Card Value Amount"
                      value={cardValueAmount}
                      onChange={(e) => setCardValueAmount(e.target.value)}
                      min="0"
                      step="0.01"
                      required
                    />
                    {errors.cardValueAmount && <p style={{ color: 'red' }}>{errors.cardValueAmount}</p>}
                  </Form.Group>

                  <Form.Group controlId="formBasicColorTheme" className="mt-3">
                    <Form.Label>Color Theme</Form.Label>
                    <div className="d-flex align-items-center">
                      <Form.Control
                        type="color"
                        value={colorTheme}
                        onChange={(e) => setColorTheme(e.target.value)}
                        style={{ width: '50px', height: '38px', marginRight: '10px' }}
                        required
                      />
                      <Form.Control
                        type="text"
                        value={colorTheme}
                        onChange={(e) => setColorTheme(e.target.value)}
                        placeholder="#598047"
                        required
                      />
                    </div>
                    {errors.colorTheme && <p style={{ color: 'red' }}>{errors.colorTheme}</p>}
                  </Form.Group>

                  <Form.Group controlId="formBasicCardImage" className="mt-3">
                    <Form.Label>Card Image</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                    />
                    {cardImagePreview && (
                      <div className="mt-2">
                        <img
                          src={cardImagePreview}
                          alt="Card Preview"
                          style={{ maxWidth: '100%', maxHeight: '150px', border: '1px solid #ddd', borderRadius: '5px' }}
                        />
                      </div>
                    )}
                  </Form.Group>

                  <div className="d-flex gap-2 mt-4">
                    <Button
                      variant="primary"
                      type="button"
                      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)", flex: 1 }}
                      onClick={createMembershipMaster}
                      hidden={editMode}
                    >
                      {isLogin ? 'Creating...' : 'Create'}
                    </Button>
                    <Button
                      variant="primary"
                      type="button"
                      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)", flex: 1 }}
                      onClick={updateMembershipMaster}
                      hidden={!editMode}
                    >
                      {isLogin ? 'Updating...' : 'Update'}
                    </Button>
                    <Button variant="outline-secondary" type="button" onClick={resetForm} style={{ flex: 1 }}>
                      Reset
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{ padding: "0px", margin: "0px" }}>
            <Card style={{ border: "none", maxWidth: "62rem", padding: "20px", margin: "auto", height: "auto", borderRadius: "20px", fontFamily: "Arial, Helvetica, sans-serif" }}>
              <h5 style={{ color: "rgb(89, 128, 71)", fontWeight: "bold" }}>
                Membership List
                <span style={{ float: "right", fontSize: "17px", color: "black", fontWeight: "bold" }}>
                  <Form.Control
                    type="text"
                    placeholder="Search by name, description, or amount..."
                    value={searchQuery}
                    onChange={handleSearchInput}
                    style={{ width: '300px' }}
                  />
                </span>
              </h5>

              <Table responsive className="mt-3">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Validity Period</th>
                    <th>Card Value</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedMemberships.length > 0 ? (
                    paginatedMemberships.map((membership, index) => (
                      <tr key={membership.id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>

                        <td>
                          <div className="d-flex align-items-center">
                            {membership.color_theme && (
                              <div
                                style={{
                                  width: '20px',
                                  height: '20px',
                                  backgroundColor: membership.color_theme,
                                  marginRight: '10px',
                                  borderRadius: '3px',
                                  border: '1px solid #ddd'
                                }}
                              />
                            )}
                            {membership.name || "---"}
                          </div>
                        </td>

                        <td>{membership.description || "---"}</td>

                        <td>
                          {membership.validity_days} days
                          <br />
                          <small>
                            {membership.validity_from && new Date(membership.validity_from).toLocaleDateString()} - 
                            {membership.validity_to && new Date(membership.validity_to).toLocaleDateString()}
                          </small>
                        </td>

                        <td>
                          ${parseFloat(membership.card_value_amt).toFixed(2)}
                        </td>

                        <td>
                          <Form.Check
                            type="switch"
                            id={`status-switch-${membership.id}`}
                            checked={membership.active_status === 1}
                            onChange={(e) =>
                              handleStatusChange(membership, e.target.checked ? 1 : 0)
                            }
                          />
                        </td>

                        <td>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="me-2"
                            onClick={() => handleEdit(membership)}
                          >
                            <i className="bi bi-pencil"></i> Edit
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">No membership plans found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
              {filteredMemberships.length > 0 && (
                <Pagination
                  activePage={currentPage}
                  itemsCountPerPage={itemsPerPage}
                  totalItemsCount={filteredMemberships.length}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                  innerClass="pagination justify-content-end"
                  activeClass="active-pagination"
                />
              )}
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Membershipmaster;